
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { 
  Plus, 
  Calendar,
  MapPin,
  DollarSign,
  Clock,
  Users
} from "lucide-react";

export const GigsPage = () => {
  const upcomingGigs = [
    {
      id: 1,
      venue: "Skyline Lounge",
      date: "This Friday",
      time: "10:00 PM - 2:00 AM",
      payment: "$400",
      status: "Confirmed",
      location: "Downtown"
    },
    {
      id: 2,
      venue: "Club Nova",
      date: "Next Saturday",
      time: "11:00 PM - 4:00 AM",
      payment: "$500",
      status: "Pending",
      location: "West End"
    }
  ];

  const pastGigs = [
    {
      id: 3,
      venue: "The Grand",
      date: "Last Friday",
      time: "10:00 PM - 2:00 AM",
      payment: "$450",
      rating: 4.8,
      attendance: 250
    },
    {
      id: 4,
      venue: "Elevation",
      date: "Two weeks ago",
      time: "9:00 PM - 1:00 AM",
      payment: "$350",
      rating: 4.9,
      attendance: 180
    }
  ];

  const stats = [
    {
      title: "Total Gigs",
      value: "24",
      change: "+3 this month",
      icon: Calendar
    },
    {
      title: "Revenue",
      value: "$9,600",
      change: "+15% vs last month",
      icon: DollarSign
    },
    {
      title: "Avg. Rating",
      value: "4.8",
      change: "From 42 reviews",
      icon: Users
    }
  ];

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h1 className="text-3xl font-bold">My Gigs</h1>
        <Button>
          <Plus className="mr-2 h-4 w-4" />
          Add New Gig
        </Button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {stats.map((stat, i) => (
          <Card key={i} className="p-6">
            <div className="flex justify-between items-start">
              <div>
                <p className="text-sm text-muted-foreground">{stat.title}</p>
                <h3 className="text-2xl font-bold mt-1">{stat.value}</h3>
              </div>
              <stat.icon className="h-5 w-5 text-muted-foreground" />
            </div>
            <p className="text-sm text-green-500 mt-2">{stat.change}</p>
          </Card>
        ))}
      </div>

      <Card className="p-6">
        <h2 className="text-xl font-semibold mb-4">Upcoming Gigs</h2>
        <div className="space-y-4">
          {upcomingGigs.map((gig) => (
            <div key={gig.id} className="flex items-center justify-between p-4 border rounded-lg">
              <div className="space-y-1">
                <h3 className="font-medium">{gig.venue}</h3>
                <div className="flex items-center gap-2 text-sm text-muted-foreground">
                  <Calendar className="h-4 w-4" />
                  {gig.date}
                  <Clock className="h-4 w-4 ml-2" />
                  {gig.time}
                </div>
                <div className="flex items-center gap-2 text-sm text-muted-foreground">
                  <MapPin className="h-4 w-4" />
                  {gig.location}
                </div>
              </div>
              <div className="text-right">
                <Badge 
                  variant={gig.status === "Confirmed" ? "default" : "secondary"}
                  className="mb-2"
                >
                  {gig.status}
                </Badge>
                <p className="font-medium text-green-500">{gig.payment}</p>
              </div>
            </div>
          ))}
        </div>
      </Card>

      <Card className="p-6">
        <h2 className="text-xl font-semibold mb-4">Past Gigs</h2>
        <div className="space-y-4">
          {pastGigs.map((gig) => (
            <div key={gig.id} className="flex items-center justify-between p-4 border rounded-lg">
              <div className="space-y-1">
                <h3 className="font-medium">{gig.venue}</h3>
                <div className="flex items-center gap-2 text-sm text-muted-foreground">
                  <Calendar className="h-4 w-4" />
                  {gig.date}
                  <Clock className="h-4 w-4 ml-2" />
                  {gig.time}
                </div>
                <div className="flex items-center gap-2 text-sm text-muted-foreground">
                  <Users className="h-4 w-4" />
                  {gig.attendance} attendees
                </div>
              </div>
              <div className="text-right">
                <p className="font-medium mb-1">Rating: {gig.rating}</p>
                <p className="font-medium text-green-500">{gig.payment}</p>
              </div>
            </div>
          ))}
        </div>
      </Card>
    </div>
  );
};
